import React from 'react'
import { FormControl, OutlinedInput, InputAdornment, IconButton, Tooltip } from "@mui/material";
import CancelIcon from '@mui/icons-material/Cancel';
import InfoIcon from '@mui/icons-material/Info';
import { useLang } from "~/hooks/useLang";

export default function FilterKeyword({ keyWords, label = 'Keywords' }) {
  const { translate } = useLang();

  return (

    <FormControl variant="standard" fullWidth>
      <OutlinedInput
        id="outlined-search"
        value={keyWords.get() ?? ''}
        size='small'
        placeholder={translate(label)}
        onChange={(event) => {
          keyWords.set(event.target.value)
        }}
        endAdornment={
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle clear search"
              onClick={() => {
                keyWords?.set('')
              }}
              edge="end"
            >
              {(keyWords?.get() || '').length ? <CancelIcon fontSize='small' /> : ''}
            </IconButton>
            <Tooltip title={translate('Use ; to separate the keywords')}>
              <IconButton edge="end">
                <InfoIcon fontSize='small'  color='inherit'/>
              </IconButton>
            </Tooltip>
          </InputAdornment>
        }
      />
    </FormControl>

  )
}